// Paso 3 familia (21-oct-2026): aviso de pieza de la otra familia (aviso, no candado).
import { FAMILY_LABELS } from './format';

export const crossFamilyText = (jobFamily, lineFamily) =>
  `This is an ${FAMILY_LABELS[jobFamily].label} job. ` +
  `This ${FAMILY_LABELS[lineFamily].label.toLowerCase()} piece will be commissioned as ` +
  `${FAMILY_LABELS[jobFamily].label}, together with the rest of the job.\n\nAdd it anyway?`;

// Envia; si el backend responde 409 CROSS_FAMILY pide confirmacion y reintenta UNA vez
// con cross_family_ack: true. Cualquier otro error se propaga tal cual.
export async function sendWithCrossFamilyAck(send, payload) {
  try {
    return await send(payload);
  } catch (err) {
    const d = err.response && err.response.data;
    if (!err.response || err.response.status !== 409 || !d || d.code !== 'CROSS_FAMILY' || payload.cross_family_ack) throw err;
    if (!window.confirm(d.error || 'This piece belongs to the other family. Add it anyway?')) {
      const e = new Error('cancelled'); e.cancelled = true; throw e;
    }
    return await send({ ...payload, cross_family_ack: true });
  }
}
